
import { Injectable } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { Observable } from "rxjs";
import { FOOTER_CATEGORIES_SELECTOR, SITE_THEME_SELECTOR, SOCIALS_SELECTOR, STATIC_PAGES_SELECTOR } from "./store/FooterThemes.selectors";
import { GET_FOOTER_CATEGORIES_ACTION, GET_SITE_THEME_ACTION, GET_SOCIALS_ACTION, GET_STATIC_PAGES_ACTION } from "./store/FooterThemes.actions";





@Injectable({ providedIn: 'root' })
export class FooterFacade 
{
  
  
  categories_selector$: Observable<any> = this.store.pipe( select(FOOTER_CATEGORIES_SELECTOR) );
  static_pages_selector$: Observable<any> = this.store.pipe( select(STATIC_PAGES_SELECTOR) );
  socials_selector$: Observable<any> = this.store.pipe( select(SOCIALS_SELECTOR) );
  site_theme_selector$: Observable<any> = this.store.pipe( select(SITE_THEME_SELECTOR) );

  

   constructor(
      private store: Store<any>, 
   ) {}



   get_static_pages() 
   {
      this.store.dispatch(new GET_STATIC_PAGES_ACTION());
   }

  
   get_categories() 
   {
      this.store.dispatch( new GET_FOOTER_CATEGORIES_ACTION() );
   }


   get_socials() 
   {
      this.store.dispatch( new GET_SOCIALS_ACTION() );
   }

   get_site_theme() 
   {
      this.store.dispatch( new GET_SITE_THEME_ACTION() );
   }



}
